import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { clearState } from '@chama/utils/functions/local-storage';
import './index.css';

const propTypes = {
  locale: PropTypes.string.isRequired,
  setLocale: PropTypes.func.isRequired,
  disableDebugging: PropTypes.func.isRequired,
  debuggingEnabled: PropTypes.bool.isRequired,
};

class DebugBar extends Component {
  state = {
    collapsed: true,
  };

  componentWillMount() {
    this.enableDebuggingIfNeeded(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.enableDebuggingIfNeeded(nextProps);
  }

  enableDebuggingIfNeeded({ router, enableDebugging }) {
    if (router && router.location.hash === '#debug') {
      enableDebugging();
      router.replace({ ...router.location, hash: '' });
    }
  }

  toggleLocale = () => {
    const { locale, setLocale } = this.props;
    if (locale === 'pt-BR') {
      setLocale('en');
    } else {
      setLocale('pt-BR');
    }
  };

  clearCacheAndHardReload = () => {
    clearState();
    window.location.href = window.location.origin;
  };

  render() {
    const { debuggingEnabled, locale, disableDebugging } = this.props;
    const { collapsed } = this.state;

    if (!debuggingEnabled) {
      return null;
    }

    if (collapsed) {
      return (
        <button
          type="button"
          className="DebugBar DebugBar--pony"
          onClick={() => this.setState({ collapsed: false })}
        />
      );
    }

    return (
      <div className="DebugBar DebugBar--panel">
        <button type="button" className="DebugBar__button" onClick={this.toggleLocale}>
          switch language: {locale === 'pt-BR' ? '🇧🇷' : '🇺🇸'}
        </button>
        <button type="button" className="DebugBar__button" onClick={disableDebugging}>
          turn debugging off
        </button>
        <button type="button" className="DebugBar__button" onClick={this.clearCacheAndHardReload}>
          empty localStorage & hard reload
        </button>
        <button
          type="button"
          className="DebugBar__button"
          onClick={() => this.setState({ collapsed: true })}
        >
          minimize
        </button>
      </div>
    );
  }
}

DebugBar.propTypes = propTypes;

export default DebugBar;



// WEBPACK FOOTER //
// ../ui-components/components/DebugBar/index.jsx